const { Fragment } = wp.element;

function Popup({ poster }) {
  return (
    <Fragment>
      <div className="h5vp_popup_overlay"></div>
      <div className="h5vp_popup">
        <img src={poster} alt="" />
        <svg aria-hidden="true" focusable="false">
          <use href="#plyr-play"></use>
        </svg>
      </div>
    </Fragment>
  );
}

export default Popup;
